import React, {useState} from 'react';
import {contentUtils} from "mindsets-js-sdk";


import './component-accordion.scss';


export default function ({component_data}) {

    const items = component_data.data && component_data.data.items ? component_data.data.items : [];
    const [expanded, setExpanded] = useState(Array(items.length));

    const renderItems = () => {
        const render_items = items.map((item, k) => {
            const icon_class = _.get(item, 'icon.class', 'fas fa-compass');
            let icon_style = _.get(item, 'icon.style', {});
            const title_text = _.get(item, 'title.text');
            let title_style = _.get(item, 'title.style', {});
            const content_html = _.get(item, 'content.html');
            const content_style = _.get(item, 'content.style');
            const header_color = _.get(item, 'header_color');
            let toggle_style = {};

            if (header_color) {
                icon_style = {...icon_style, color: header_color}
                title_style = {...title_style, color: header_color}
                toggle_style = {...toggle_style, color: header_color}
            }

            const content_style_plus = {
                display: 'none',
                ...content_style
            }
            if (!!expanded[k]) {
                content_style_plus.display = 'block';
            }

            let toggle_class_names = 'cc-accordion-item-head-toggle';
            if (!expanded[k]) {
                toggle_class_names += ' fas fa-chevron-down';
            } else {
                toggle_class_names += ' fas fa-chevron-up';
            }

            const onClick = () => {
                const expanded_clone = _.clone(expanded);
                expanded_clone[k] = !expanded_clone[k];
                setExpanded(expanded_clone);
            }

            return (
                <div key={k} className="cc-accordion-item">
                    <div className="cc-accordion-item-head d-flex align-items-center" onClick={onClick}>
                        <i className={`cc-accordion-item-head-icon ` + icon_class} style={icon_style}></i>
                        <div className="cc-accordion-item-head-title" style={title_style}>
                            {title_text}
                        </div>
                        <i className={toggle_class_names} style={toggle_style}></i>
                    </div>

                    <div className="cc-accordion-item-content" style={content_style_plus}>
                        {contentUtils.processStringContent(content_html)}
                    </div>
                </div>
            );
        });
        return (
            <div>
                {render_items}
            </div>
        );
    }

    return (
        <div className="challenge-component-accordion">
            <div>
                {renderItems()}
            </div>
        </div>
    );
}